const TokenStorage = {
    TYPE_ID: 'ID_TOKEN',
    TYPE_REFRESH: 'REFRESH_TOKEN',
    setToken: (type, token) => {
        window.localStorage.setItem(type, token);
    },
    hasToken: (type) => {
        return window.localStorage.getItem(type) !== null;
    },
    getToken: (type) => {
        return window.localStorage.getItem(type);
    },
    removeToken: (type) => {
        window.localStorage.removeItem(type);
    }
};

export default TokenStorage;


// WEBPACK FOOTER //
// ./src/services/TokenStorage.js